import React, {Component, ErrorInfo, ReactNode} from 'react';
import {history} from '@umijs/max';
import {Button, Result} from "antd";
import {PageContainer} from "@/components";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
    errorInfo?: ErrorInfo;
}

class GlobalErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error: Error): State {
        // 发生错误时更新状态
        return {hasError: true, error};
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // 捕获错误信息
        this.setState({error, errorInfo});

        // 错误上报逻辑（可选）
        console.error('全局错误捕获:', error, errorInfo);

        // 可以选择跳转到错误页面或在这里直接展示错误信息
        // history.push('/exception/500', { error: error.message });
    }

    // 重置错误状态
    private resetErrorBoundary = (): void => {
        this.setState({hasError: false, error: undefined, errorInfo: undefined});
    };

    render() {
        if (this.state.hasError) {
            // 错误状态下的 UI
            return (
                <PageContainer>
                    <Result
                        status="500"
                        title="抱歉，页面发生错误"
                        subTitle={this.state.error?.message}
                        extra={[
                            <Button
                                onClick={this.resetErrorBoundary}
                                className="ant-btn ant-btn-primary"
                                style={{marginTop: '1rem'}}
                            >
                                尝试恢复
                            </Button>,
                            <Button
                                type={'primary'}
                                onClick={() => {
                                    this.resetErrorBoundary();
                                    history.push('/')
                                }}
                                className="ant-btn"
                                style={{marginLeft: '1rem', marginTop: '1rem'}}
                            >
                                返回首页
                            </Button>
                        ]}
                    />
                </PageContainer>
            )
                ;
        }

        // 正常状态下渲染子组件
        return this.props.children;
    }
}

export default GlobalErrorBoundary;
